module.exports = __webpack_public_path__ + "static/scale-model-of-jimi-hendrix-statue-in-seattle-washington-ca4d2e5f8571cf4ace061b2849a51481.png";